import { render, staticRenderFns } from "./navbar-booking-paid.vue?vue&type=template&id=400f1283"
import script from "./navbar-booking-paid.vue?vue&type=script&lang=js"
export * from "./navbar-booking-paid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports